export const COLORS = {
  GREEN:        '#73C724',
  MEDIUM_GREEN: '#ABE872',
  LIGHT_GREEN:  '#D2E8BE',

  RED: '#FF5454',

  DARK_BLUE:  '#2F72A8',
  BLUE:       '#5698D6',
  LIGHT_BLUE: '#8FC1FF',

  WHITE:         '#FFFFFF',
  LIGHTEST_GREY: '#F5F5F5',
  LIGHTER_GREY:  '#EBEBEB',
  LIGHT_GREY:    '#C8C8C8',
  FIELD_GREY:    '#ABABAB',
  MENU_GREY:     '#9E9E9E',
  MEDIUM_GREY:   '#828282',
  DARK_GREY:     '#474747',
  BLACK:         '#000000',

  DISABLED:  '#D6D6D6',
  ICON_GREY: '#666666',
  PAGE_BG:   '#EBEBEB',

  HOVER_GREY: '#757575',

  PROJECTBAR_GREY:     '#CFCFCF',
  PARTICIPANTBAR_GREY: '#DADADA',

  // Used in the dev plan cards for 0 unread comment notifications
  UNREAD_GREY: '#7D7D7D',
};

export const CHART_COLORS = {
  RING_BG: '#D6D6D6',
  PERSON:  '#D6D6D6',

  LEVELS: [
    '#3E7BC7',
    '#5698D6',
    '#73ABF0',
    '#A7B6FC',
    '#C3CDFA',
    '#575757',
    '#707070',
    '#969696',
    '#B3B3B3',
    '#C7C7C7',
  ],
};

export const TABLE_COLORS = {
  DARK_BG:  '#F4F4F4',
  LIGHT_BG: '#FAFAFA',
  BORDER:   COLORS.LIGHTER_GREY,
};
